import { useEffect, useState } from "react"

import { useLocation } from "react-router-dom"

import dataTransitionMain from "./index"

export const transitionTypes = {
    fromReorderThresholdToPurchaseOrder: {
        id: "fromReorderThresholdToPurchaseOrder"
    },
    fromRelocateThresholdToItemRelocate: {
        id: "fromRelocateThresholdToItemRelocate"
    }
}

export function useDataTransitions({
    transitionType: _transitionType
}) {

    const _useReorderThresholdToPurchaseOrder = dataTransitionMain.useReorderThresholdToPurchaseOrder()
    const _useRelocateThresholdToItemRelocate = dataTransitionMain.useRelocateThresholdToItemRelocate()

    const [transitionType, setTransitionType] = useState(_transitionType)

    const location = useLocation();
    const locationState = location?.state ? location.state : {}

    // console.log('locationState', locationState)

    const initialTransition = ({ data = [], overrideTransitionType = '' }) => {

        let _transitionType = transitionType

        if (overrideTransitionType) _transitionType = overrideTransitionType

        let nextRoute = ''
        let transitionData;

        if (_transitionType === transitionTypes.fromReorderThresholdToPurchaseOrder.id) {

            let { nextRouteUrl, nextRoutePayload } = _useReorderThresholdToPurchaseOrder.init({ data })

            nextRoute = nextRouteUrl
            transitionData = nextRoutePayload

        }

        if (_transitionType === transitionTypes.fromRelocateThresholdToItemRelocate.id) {

            let { nextRouteUrl, nextRoutePayload } = _useRelocateThresholdToItemRelocate.init({ data })

            nextRoute = nextRouteUrl
            transitionData = nextRoutePayload

        }

        return {
            nextRoute,
            nextRouteParams: {
                state: {
                    transitionType,
                    transitionData
                }
            },
        }

    }

    const catchTransition = ({ formik }) => {

        const {
            transitionType,
            transitionData
        } = locationState

        let data = transitionData

        if (transitionType === transitionTypes.fromReorderThresholdToPurchaseOrder.id) {
            _useReorderThresholdToPurchaseOrder.catchTransition({ formik, data })
        }

        if (transitionType === transitionTypes.fromRelocateThresholdToItemRelocate.id) {
            _useRelocateThresholdToItemRelocate.catchTransition({ formik, data })
        }

    }

    return {
        initialTransition,
        catchTransition
    }
}